import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
// import { faClockFour } from "@fortawesome/free-solid-svg-icons";
import { ablyClient } from "../../lib/socket";
import { generateQueryParams } from "../../lib/utils";
const channel = ablyClient.channels.get("admin-redeem");
const initialState = {
  page: 0,
  rowsPerPage: 10,
  totalRedeems: 0,
  data: [],
  filters: {},
  loading: false,
  error: null,
};

const RedeemSlice = createSlice({
  name: "redeem",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    ApiSuccess: (state, action) => {
      state.data = action.payload.redeems;
      state.totalRedeems = action.payload.totalRedeems;
      state.loading = false;
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    updateRequest: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
  },
});

// Actions
export const {
  requestStart,
  ApiSuccess,
  requestFailure,
  setFilters,
  setPage,
  setRowsPerPage,
  updateRequest,
} = RedeemSlice.actions;

export const RedeemRequestSlice =
  (page, limit, filters) => async (dispatch) => {
    try {
      dispatch(requestStart());
      const response = await axios.get(
        `/private/backend/redeem?${generateQueryParams({
          ...filters,
          page,
          limit,
        })}`,
      );
      dispatch(ApiSuccess(response.data));
    } catch (err) {
      toast.error(
        err?.response?.data?.message || err.message || err.msg || "failed!",
      );
      dispatch(
        requestFailure(err?.response?.data?.message || "Something went wrong!"),
      );
    }
  };

export const RedeemActionSlice = (data) => async (dispatch) => {
  try {
    const response = await axios.post(`/private/backend/redeem`, data);
    dispatch(updateRequest(response.data));
    await channel.publish("admin-redeem", data);
    toast.success("Request approved successfully");
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!",
    );
    return null;
  }
};

export const RedeemActionRejectSlice = (data) => async (dispatch) => {
  try {
    const response = await axios.put(`/private/backend/redeem`, data);
    dispatch(updateRequest(response.data));
    await channel.publish("admin-redeem", data);
    toast.success("Request rejected successfully");
    return null;
  } catch (err) {
    toast.error(
      err?.response?.data?.message || err.message || err.msg || "failed!",
    );
    return null;
  }
};
export default RedeemSlice.reducer;
